import { Badge } from '../../engine/design/primitives/Misc';

/** Invoice list "Number" cell: drafts have no number yet; credit notes carry a badge. */
export function InvoiceNumberCell({ row }: { row: Record<string, unknown> }) {
  return (
    <span className="hf-row" style={{ gap: 6 }}>
      {row.number ? String(row.number) : <span className="hf-muted">draft</span>}
      {row.kind === 'credit_note' && <Badge tone="warn">credit note</Badge>}
    </span>
  );
}
